import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { BIDDING_SLICE_NAME, BiddingState } from './models';

const selectBiddingState = (state: RootState): BiddingState => state[BIDDING_SLICE_NAME];

export const biddingSelector = createSelector([selectBiddingState], (biddingState) => biddingState);

export const bidsListSelector = createSelector([selectBiddingState], (biddingState) => biddingState.bidsList);

export const biddingIsLoadingSelector = createSelector([selectBiddingState], (biddingState) => biddingState.isLoading);

export const biddingErrorSelector = createSelector([selectBiddingState], (biddingState) => biddingState.error);

export const biddingPaginationSelector = createSelector([selectBiddingState], (biddingState) => ({
  next: biddingState.bidsList?.cursor?.next,
  prev: biddingState.bidsList?.cursor?.prev,
}));

export const selectBiddingError = biddingErrorSelector;
